import React from 'react';
import {SvgIcon, SvgIconProps} from '@mui/material';

/**
 * Munich Icon component showing the Munich child from the Munich coat of arms.
 */
export default function MunichIcon({colored = false, ...props}: {
    colored?: boolean;
} & SvgIconProps) {
    return (
        <SvgIcon {...props} viewBox="-4 20 220 220">
            {/* Red parts (Book and shoes) */}
            <path
                d="m182.9 50.725 9.3 18.98-13 7.05-9.2-19.43z"
                fill={colored ? '#ed1c24' : 'currentColor'}
            />
            <path
                d="M91.31 200.125c-1.29.4-1.91 4.3-3.41 6.2-1.94 2.5-10.66 7.8-10.66 18.3 5.79-3.7 8.28-5.5 14.28-9.8 4.88-3.4 7-3.9 7.44-4.5v-10.2zm24.69 0c.1 6.5 0 9.1.6 10.2 1.1 1.5 3.4 1.7 8.6 5.6 4.8 3.8 7.4 5.9 12.3 8.7-.9-11.7-3.6-10.9-7.9-15.8-2.3-2.1-5.5-8.5-5.7-8.7z"
                fill={colored ? '#ed1c24' : 'currentColor'}
            />

            {/* Hands/Face */}
            <path
                d="M164.4 79.525h7.8l6.6-3.75-3.9-8.26 6.9-4.74-.9-2.25-8.7 5m-135.8-4.9-7.9-7.48-2.62 5.5 10.52 4.88m10.6 7-8.38-16.5-1.22 6.6 9.6 18.9m-7.6-16.9h-4c-1.64 2.89-3.55 5.71-4.4 8l8.4 1"
                fill={colored ? '#fbc2a6' : 'currentColor'}
            />
            <path
                d="M93.65 34.145c-.25.02-.51.06-.75.12-7.37 3.25-3.64 10.38-5.88 21.5l2.38.5c0 2.37.38 3.87.72 6.75 6.63.62 10.38-.25 10.88 0 1.7 1.5 4.3 6.88 4.3 6.88l.5-.25s.9-24.38.2-26.38c-.6-3.12-4.1-6-6.72-7.62-1.76-.88-3.86-1.66-5.63-1.5zm-65.16 19-1.12 2c4 3.12 6.62 4.12 8.12 5.5l-.5 1.25c-2.12-1-7.12-4.26-8.25-4.88l-.87 1.63c3.88 2.74 7.5 4.63 8.25 5.25 2.13 1.13 4.13 1.12 5.25 2.25v1.62c-2.88-.62-4.75-2.38-6-1.62l-.88 1.25c2.13 0 5.38 2.12 5.38 2.12l-.5 1.5c-2.5-.87-2.73-1.63-5.59-2.25l-1 2.25 23 12.38-.07-12.28c-.74-.23-1.46-.63-2.09-.97-3.63-2.25-1.63-6-2.13-7.25 0-.25-7.86-6.76-10.87-8.88-2.5 3.5 2.87 5.88 3.87 7.63 1.75 2.62-.12 6.75 4.38 9.5l-.13 2c-6.75-1.88-4.5-8.26-5.75-10.63-1.25-1.5-2.25-2-4-3.25-3.27-2.25-5.37-4.24-8.5-6.12zm150.5 5.34c-.2-.01-.6.08-1 .28l-6.1 3.07c-2.5 1.5-4.2 2.4-4.2 2.4-2.4 1.3 1.9 5.49-1.4 6.72-1.5.58-2.9 1.2-3.9 1.47v13.2l14.5-8.79-2.3-4.79c-1.1 3.4-2.9 4.5-6.1 5.1l-.5-2c2.6-.8 4.3-1.39 5-4.19.4-2.1-1-3.1-.1-5 .1-.5 3.7-2.91 6.1-4.41.8-.5 1.6-.89 1.9-1.09-.7-1.07-1.1-1.94-1.9-1.97z"
                fill={colored ? '#fbc2a6' : 'currentColor'}
            />

            {/* Black Robe */}
            <path
                d="M99.7 33.145c5.7 2.7 6.5 3.79 8.7 6.69 1.3 2.6 1.2 5 1.2 15.4 0 6.7-.6 13.11-.5 13.41l-6.8 1.9c-.6-.2-1.8-3.29-2.9-4.59-6 6.8-15.17 8.68-23.25 9.28-4.56.6-17.72-2.1-23-4.4 0 0-.27 86.59-.28 126.4 7.3 0 12.65-2.3 16.94-9.1 1.07-1.3 2.34-3.8 2.34-15.3 0-12 .09-57.4.09-57.4 0-2.8 1.91-6.5 4.91-9.3 2.31-2.2 4.07-3.1 7.16-3.9v94.2l48.09.2v-95.8c2.4.8 5.8 3.2 7.3 5.4 1.5 2.1 3.3 4.4 4.6 9.1 1.3 6 .7 56.3.7 57.4 0 8-.7 14.2 2.7 19.1 3 4.1 11.1 6.2 15.6 6.6v-126.3c-9.3 3.12-20.3 4.31-28.8 2.61-7.3-1.3-12.3-6.8-12.8-7.9-3.8-7.7 13.9-5.79 21.5-5.79-1-5.7-1.9-7.2-4-11.5-4.2-7.2-7.9-10.4-14.7-13.4-6-2.3-18.8-3-24.8-3z"
                fill={colored ? '#000' : 'currentColor'}
            />

            {/* Yellow trim and Cross */}
            {colored && (
                <path
                    d="M93.22 33.825c-.64 1.29 3.42.38 3.92 1.79.5 1.42 4.49 27.9 4.49 27.9l-2.29 2.48v6.4h11.01v-37.08c-5.1-.38-9.2-3.49-17.08-1.49z"
                    fill={colored ? '#fd0' : 'currentColor'}
                />
            )}
            {colored && (
                <path
                    d="M110.2 91.145c8.625-.25 15-3.375 18.62-7.125 2.125-2 4-3.875 4.75-6.75l-3.5-1.375c-.625 2.25-1.75 3.375-3.5 5-3.375 3.5-10.38 6.5-18.5 6.5-6.75 0-12.75-2.25-16.5-4.75-2.875-1.875-4.75-3.625-5.75-6.75l-3.45 1.62c1 3.625 3.75 6.25 7.125 8.375 4 2.75 9.25 5 16.12 5.25v35.37h-19.2v4.25h19.25v63.62h4.5v-63.6h20.12v-4.25h-20V91.05Z"
                    fill={colored ? '#fd0' : 'currentColor'}
                />
            )}

            {/* Eyes/Face details */}
            <path
                d="M102.2 42.525c.1-2.25-.4-2.5-2.4-4.5-.75 2.38-.4 3.25 2.4 4.5zm-2.92.12c.12-2.24.32-2.86-2-4.62-.62 2.38-.62 3.12 2 4.62zm-2.88-.24c.25-2.26.75-2.64-2-4.63-.62 2.37-.5 3.5 2 4.63zm-3.18.25c.76-2.01 1.26-3.38-1.87-4.75-.37 2.75.25 3 1.87 4.75zm-.2 5.74c3.38 1.75 3.62 1.75 6.88-.37-1-1.88-2.76-3.13-5-2.63-1.26.62-1.76 1.37-1.88 2.74z"
                fill={colored ? '#231f20' : 'currentColor'}
            />
        </SvgIcon>
    );
}
